<script setup>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";

const router = useRouter();
const auth = useAuthStore();

onMounted(async () => {
  try {
    const returnPath = await auth.completeLogin();
    router.replace(returnPath || "/");
  } catch (err) {
    console.error("OIDC callback failed", err);
    router.replace("/");
  }
});
</script>

<template>
  <v-container class="d-flex justify-center align-center" style="min-height: 50vh">
    <v-progress-circular indeterminate color="primary" />
  </v-container>
</template>
